import { fhirR4 } from "@smile-cdr/fhirts";

/**
 * Days of the week, FHIR dayOfWeek codes. Ordered Monday → Sunday.
 */
export type DayOfWeek = "mon" | "tue" | "wed" | "thu" | "fri" | "sat" | "sun";

export const DAYS_OF_WEEK: DayOfWeek[] = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

/**
 * Operating hours for a single day of the week.
 * `start`/`end` are 24h "HH:mm" strings (e.g. "08:00", "16:00").
 * When `open` is false the day is considered closed and times are ignored.
 */
export interface ClinicDayHours {
  day: DayOfWeek;
  open: boolean;
  start: string;
  end: string;
}

/**
 * An educational link configured per clinic and shown to patients.
 */
export interface ClinicEducationalResource {
  label: string;
  url: string;
}

/**
 * Clinic option for select dropdowns
 */
export interface ClinicOption {
  id: string;
  value: string; // "Organization/{id}"
  label: string; // Clinic name
  phoneNumber?: string;
  active: boolean;
  primaryContactName?: string;
  primaryContactId?: string;
  /** IANA timezone identifier (e.g. "America/Toronto"), for dates shown in the clinic's local time. */
  timezone?: string;
}

/**
 * Clinic row data for DataGrid
 */
export interface ClinicRowData {
  id: string;
  name: string;
  primaryContact: string;
  phoneNumber: string;
  status: boolean;
}

/**
 * Clinic form data for add/edit modal
 */
export interface ClinicFormData {
  name: string;
  phoneNumber: string;
  primaryContactRef?: fhirR4.Reference;
  /** IANA timezone identifier (e.g. "America/Toronto") */
  timezone: string;
  /** Operating hours, always 7 entries ordered Monday → Sunday */
  hours: ClinicDayHours[];
  /** ISO 3166-1 alpha-2 country code; "" = no country */
  country: string;
  /** Digits only, 2–4 characters; "" = none stored */
  emergencyNumber: string;
  /** Educational links shown to patients; [] = none stored */
  educationalResources: ClinicEducationalResource[];
}
